import { useSnackbar } from "notistack";
import { useState } from "react";
import { useIntl } from "react-intl";
import { createCompany, editCompany } from "../../../../../crud/companies.crud";
import { getResponseMessage } from "../../../../../utils";

export const useCompany = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const intl = useIntl();

  const create = async ({ short_name, userId }: { short_name: string; userId?: number }) => {
    setLoading(true);
    createCompany({ short_name, userId })
      .then(res => {
        setSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: "ERROR" })}: ${getResponseMessage(e)}`, { variant: "error" });
      })
      .finally(() => {
        setLoading(false);
        setSuccess(false);
      });
  };

  const edit = async ({ short_name, company_id }: { short_name: string; company_id: number }) => {
    setLoading(true);
    editCompany(company_id, { short_name })
      .then(res => {
        setSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: "ERROR" })}: ${getResponseMessage(e)}`, { variant: "error" });
      })
      .finally(() => {
        setLoading(false);
        setSuccess(false);
      });
  };

  return {
    loading,
    success,
    create,
    edit,
  };
};
